import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, Validators, FormArray, FormGroup, NgControl } from '@angular/forms';
import { Phone } from '@models/peripherals/phone';
import { PhoneForm } from '@models/peripherals/phone-form';
import {PhoneMaskDirective} from './phone-mask.directive';
import {ConfirmPopupComponent} from '@shared/modal-popup/confirm-popup/confirm-popup.component';
@Component({
  selector: 'app-phonearray',
  templateUrl: './phonearray.component.html',
  styleUrls: ['./phonearray.component.css']

})
export class PhonearrayComponent implements OnInit {
  @ViewChild(ConfirmPopupComponent) confirmModal: ConfirmPopupComponent;
  public isCollapsed = true;
  private phoneType: string[];
  selectColor = '#aaaaaa';
  phoneCounter: number;
  number;
  // num:number;

  @Input()
  public parentId: number;

  @Output() deletePhoneEvent: EventEmitter<number> = new EventEmitter();

  @Input()
  public phoneForm: PhoneForm[];

  @Input()
  public phoneFormArray: FormArray;

  @Input()
  public phoneTypes: string[];

  @Output() rawChange: EventEmitter<string> = new EventEmitter<string>();

  static buildPhones() {
    return new FormArray([
      this.buildPhone(''),
    ]);
  }
  // constructor(public model: NgControl) {}
  static buildFormPhone(val: PhoneForm): any {
    return new FormGroup({
      phone_id: new FormControl(val.phoneID),
      number: new FormControl(val.phoneNumber),
      phoneType: new FormControl(val.type),
      phoneAbout: new FormControl(val.about)
    });
  }

  static buildPhone(val: string): any {
    return new FormGroup({
      phone_id: new FormControl(null),
      number: new FormControl(val),
      phoneType: new FormControl(null),
      phoneAbout: new FormControl(val)
    });
  }

  ngOnInit() {
    if (this.phoneForm) {
      this.phoneFormArray.removeAt(0);
      this.selectColor = '#000000';
      this.phoneForm.forEach(element => {
        this.phoneFormArray.push(PhonearrayComponent.buildFormPhone(element));
      });
    }
    this.phoneCounter = this.phoneForm.length;
  }

  addPhone() {
    this.phoneFormArray.push(PhonearrayComponent.buildPhone(''));
    this.isCollapsed = false;
    this.phoneCounter = this.phoneCounter + 1;
  }

  changetxtRecord() {
    this.selectColor = '#000000';
  }

  deletePhone(index) {
    let phone_id = this.phoneFormArray.controls[index.map_id].get('phone_id').value;

    if (this.parentId) {
      // emit an event
      // if (confirm('Do you want to delete this phone number ?')) {
        this.deletePhoneEvent.emit(phone_id);
        this.phoneFormArray.removeAt(index.map_id);
        this.confirmModal.closeModal();
      // }
    } else {
      this.phoneFormArray.removeAt(index.map_id);
      this.confirmModal.closeModal();
    }
    this.phoneCounter = this.phoneCounter - 1;
  }
  validNumber(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  openConfirm(id){
    this.confirmModal.showModal(id);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/form-control/phone-form-control/phonearray.component.ts